import { useNavigate } from "react-router-dom";
import { Drawer, DrawerContent, DrawerTitle, DrawerDescription } from "@/components/ui/drawer";
import useLieferanten from "@/hooks/useLieferanten";
import { ScanBarcode, LayoutGrid, ClipboardList, ChevronRight } from "lucide-react";

/**
 * "Bestellen" auf dem Handy: ein Blatt von unten mit den Wegen, die es gibt.
 *
 * Der mittlere Knopf der Leiste unten oeffnet es. Zwei grosse Karten - Komet
 * scannen, Implantat-Bauteile - und darunter die Uebersicht mit der Freigabe.
 * Grosse Flaechen, weil man am Regal steht und nicht zielt; die Kamera geht
 * auf der naechsten Seite von selbst an.
 */
export default function BestellenWahl({ offen, onOffen }) {
  const navigate = useNavigate();
  const lieferanten = useLieferanten();
  const gehe = (ziel) => { onOffen(false); navigate(ziel); };
  return (
    <Drawer open={offen} onOpenChange={onOffen}>
      <DrawerContent className="pb-[calc(1rem+env(safe-area-inset-bottom))]" data-testid="bestellen-wahl">
        <div className="px-4 pt-2 pb-3">
          <DrawerTitle className="text-base">Ware bestellen</DrawerTitle>
          <DrawerDescription className="text-xs mt-0.5">Landet in der Sammelbestellung des Lieferanten und geht zur Versandzeit raus.</DrawerDescription>
        </div>
        <div className="px-4 space-y-2">
          {lieferanten.map((l) => (
            <button key={l.id} type="button" disabled={!l.aktiv} onClick={() => gehe(`/bestellen/${l.id}`)}
                    data-testid={`bestellen-wahl-${l.id}`}
                    className="w-full text-left rounded-2xl border border-slate-200 bg-white px-4 py-3.5 flex items-center gap-3.5
                               active:bg-slate-100 disabled:opacity-50">
              <span className={`h-12 w-12 rounded-xl flex items-center justify-center shrink-0 ${
                l.scan ? "bg-slate-900 text-white" : "bg-sky-50 text-sky-800 border border-sky-200"}`}>
                {l.scan ? <ScanBarcode className="h-6 w-6" /> : <LayoutGrid className="h-6 w-6" />}
              </span>
              <span className="min-w-0 flex-1">
                <span className="block text-base font-semibold text-slate-900 leading-tight">{l.name}</span>
                <span className="block text-xs text-slate-500 mt-0.5 leading-snug">{l.beschreibung}</span>
              </span>
              <ChevronRight className="h-5 w-5 text-slate-300 shrink-0" />
            </button>
          ))}
          <button type="button" onClick={() => gehe("/bestellungen")} data-testid="bestellen-wahl-uebersicht"
                  className="w-full text-left rounded-2xl border border-dashed border-slate-300 px-4 py-3 flex items-center gap-3.5 active:bg-slate-100">
            <span className="h-10 w-10 rounded-xl bg-slate-100 text-slate-700 flex items-center justify-center shrink-0">
              <ClipboardList className="h-5 w-5" />
            </span>
            <span className="text-sm font-medium text-slate-800 flex-1">Bestellübersicht &amp; Freigabe</span>
            <ChevronRight className="h-5 w-5 text-slate-300 shrink-0" />
          </button>
        </div>
      </DrawerContent>
    </Drawer>
  );
}
